import { render, staticRenderFns } from "./FormsPreviewPane.vue?vue&type=template&id=57fcb23c&scoped=true"
import script from "./FormsPreviewPane.vue?vue&type=script&lang=js"
export * from "./FormsPreviewPane.vue?vue&type=script&lang=js"
import style0 from "./FormsPreviewPane.vue?vue&type=style&index=0&id=57fcb23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fcb23c",
  null
  
)

export default component.exports